import * as React from 'react';
import { NewsLetterBoxFormContainer } from '../container';
import { NewsLetterBoxFormSubmitButton } from '../submitButton';

export const NewsLetterBoxFormWithSubmit = (props: React.PropsWithChildren<{}>) => {
  const {
    children,
  } = props;
  return (
    <NewsLetterBoxFormContainer>
      {children}
      <NewsLetterBoxFormSubmitButton />
    </NewsLetterBoxFormContainer>
  );
};
